import { EStoreStatus } from '@gelato-api-ui/core/e-commerce/e-store-status.enum';

export const storeConnectionFailureStatuses = [EStoreStatus.REQUIRES_RECONNECTION, EStoreStatus.INACTIVE];
